<template>
  <main class="lm-tips" :style="bomCardStyles">
    <p class="title">
      {{ $t('lordsmobile.purchase_redeem_title') }}
    </p>
    <p class="header">
      {{ getRules.purchase_tips.title }}
    </p>
    <p
      class="tips-item"
      v-for="(item, index) in getRules.purchase_tips.rules"
      :key="index"
    >
      {{ item }}
    </p>
    <p class="header">
      {{ getRules.exchange_tips.title }}
    </p>
    <template v-if="!more">
      <p
        class="tips-item"
        v-for="(item, index) in getRules.exchange_tips.rules"
        :key="index + 'exchange_tips'"
      >
        {{ item }}
      </p>
    </template>
    <div class="btn-content">
      <span class="btn" @click="showMore"
        >{{ more ? $t('common.unfold') : $t('common.fold')
        }}<van-icon
          class="btn-icon"
          :class="more ? 'btn-icon-down' : 'btn-icon-up'"
          name="play"
      /></span>
    </div>
  </main>
</template>

<script>
  import { mapState } from 'vuex'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        more: true,
      }
    },
    computed: {
      ...mapState(['gameName']),
      bomCardStyles() {
        if (this.isDesktop) {
          return null
        }
        return this.moduleBackColor
      },
      getRules() {
        const purchase_tips = this.$t('lordsmobile.purchase_tips')
        const exchange_tips = this.$t('lordsmobile.exchange_tips')
        return {
          purchase_tips,
          exchange_tips,
        }
      },
    },
    mounted() {},
    methods: {
      showMore() {
        this.more = !this.more
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>

<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
  }
</style>
